import { render } from "./Dashboard.vue?vue&type=template&id=c0751b28"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=c0751b28&lang=scss"
import "./Dashboard.vue?vue&type=style&index=1&id=c0751b28&lang=css"
script.render = render

export default script